<template lang="html">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div
            @click="$emit('close')"
            class="close-modal-wrapper"
          >
            <i class="icon icon--cross"></i>
          </div>


          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <button class="btn btn--main" @click.prevent="$emit('close')">
              {{ $t('common.ok') }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  export default {
    name: 'WarningModal',
    props: [],
    data() {
      return {
        windowHeight: window.outerHeight,
      };
    },
  };
</script>

<style lang="scss" scoped>
@import '~styles/_mixins.scss';
@import '~styles/app.scss';

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    background-color: rgba(0, 0, 0, .7);
    transition: opacity .3s ease;
    min-width: 320px;
  }

  .modal-wrapper {
    bottom: 50%;
    right: 50%;
    position: fixed;
    transform: translate(50%, 50%);
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 500px;
    margin: 0px auto;
    padding: 110px 30px;
    background-color: var(--white);
    border-radius: 2px;
    @include shadow(3);
    transition: all .3s ease;
    text-align: center;
    position: relative;

    @media screen and (max-width: 550px) {
      width: calc(100vw - 20px);
      min-width: calc(320px - 20px);
    }

    .close-modal-wrapper {
      position: relative;
      top: -105px;
      left: 227px;
      font-size: 31px;
      display: inline-block;
      padding: 2px 11px;
      cursor: pointer;
      color: var(--brand-orange);
      transition: all 225ms ease-in-out;

      @media screen and (max-width: 550px) {
        position: absolute;
        top: 0;
        left: auto;
        right: 0;
      }

      &:hover {
        color: var(--brand-blue);
        transition: all 225ms ease-in-out;
      }
    }

    .modal-footer {
      justify-content: center;
      display: flex;
    }
  }

  .modal-header {
    color: var(--brand-orange);
    position: relative;
    margin-top: -40px;

    .header {
      margin-top: 0;
    }

  }

  .modal-body {
    margin: 20px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/WarningModal.vue